import type { RoomTarget, RoomUIAction } from './control-types.ts';

export const ROOM_TARGETS: readonly RoomTarget[] = ['mission','tasks','team-chat','personal-chat','workshop-chat','files','room-settings','personal-settings','activity','hud','invite','new-task','workshop-library'];
/** A capability vocabulary, never arbitrary DOM selectors or executable commands. */
export function validateRoomActions(value: unknown): RoomUIAction[] {
  if (!Array.isArray(value) || value.length > 4) throw new Error('invalid_room_actions');
  return value.map((raw) => {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) throw new Error('invalid_room_actions');
    const r = raw as Record<string, unknown>;
    const txt = (v: unknown, n: number) => { if (typeof v !== 'string' || !v.trim() || v.length > n) throw new Error('invalid_room_actions'); return v.trim(); };
    const label = txt(r.label, 80), reason = txt(r.reason, 240);
    if (r.type === 'room.draft' && typeof r.target==='string' && ['team-chat','workshop-chat','new-task'].includes(r.target)) return { type: r.type, target: r.target as 'team-chat'|'workshop-chat'|'new-task', label, reason, text: txt(r.text, 2000) };
    if ((r.type === 'room.navigate' || r.type === 'room.highlight') && ROOM_TARGETS.includes(r.target as RoomTarget)) return { type: r.type, target: r.target as RoomTarget, label, reason };
    throw new Error('invalid_room_actions');
  });
}
